'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // ------------------------------------------------------------------------------
// ---------------------------------------------------------------------- Imports
// ------------------------------------------------------------------------------
// eslint-disable-line import/no-extraneous-dependencies


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactMotion = require('react-motion');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------- Component
/**
  * MotionFade - React Element that simply wraps a fade <Motion />.
  */
var MotionFade = function MotionFade(props) {
  return _react2.default.createElement(
    _reactMotion.Motion,
    {
      defaultStyle: { opacity: 0 },
      style: { opacity: (0, _reactMotion.spring)(1, { stiffness: 210, damping: 33 }) }
    },
    function (fadeAnimation) {
      return _react2.default.createElement(
        'div',
        { style: _extends({}, fadeAnimation) },
        props.children
      );
    }
  );
};

MotionFade.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]).isRequired
} : {};

// ----------------------------------------------------------------------- Export
exports.default = MotionFade;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/@bodhi-project/components/lib/MotionFade.js
// module id = 432
// module chunks = 168707334958949